module.exports = __webpack_public_path__ + "img/biaopan.ea950a37.png";